import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, AfterViewChecked, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { Router } from '@angular/router';
import { CreateModuleReqVM } from 'src/app/viewModels/moduleMaster/create-module-req-vm';
//import { ModuleMasterService } from '../../services/moduleMaster/module-master.service';
import * as jwt_decode from 'jwt-decode';
import { ModuleMasterService } from '../services/moduleMaster/module-master.service';

@Component({
  selector: 'app-create-modules',
  templateUrl: './create-modules.component.html',
  styleUrls: ['./create-modules.component.scss']
})
export class CreateModulesComponent implements OnInit,AfterViewChecked {
  @ViewChild('moduleName', {static: true}) moduleName:ElementRef;
  OfficeIDList: any=[];
  myOfficeID: any;
  constructor(private formBuilder: FormBuilder, private customValidator: CustomvalidationService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private loaderService: LoaderService,
    private toastr: ToastrService, private router: Router,
    private createReqVM: CreateModuleReqVM, private moduleMasterService: ModuleMasterService) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);

    this.createModuleform = this.formBuilder.group({
      moduleRoute: ['', Validators.required],
      moduleName: ['', Validators.required],
      isActive: ''
    });
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });

  }

 
  createModuleform: FormGroup;
  isActiveChecked = true;
  @Output() closeSidePanel = new EventEmitter();
  addModuleResponseHolder: any;
  currentUser: any;
  

  ngOnInit(): void {
    this.moduleName.nativeElement.focus();
  }
  
  ngAfterViewChecked(){
    // setTimeout(() => {
    //   this.moduleName.nativeElement.focus();
    // }, 1);
  }

  close() {
    let closePanel = false;
    this.createModuleform.reset();
    this.closeSidePanel.emit(closePanel);
  }

  createModule(formValues) {
    if (formValues != undefined) {
      this.createReqVM.isActive = formValues.isActive;
      this.createReqVM.moduleName = formValues.moduleName;
      this.createReqVM.moduleRoute = formValues.moduleRoute;
      this.createReqVM.createdBy = this.currentUser.UID;
      this.createReqVM.officeID=this.myOfficeID
      this.loaderService.show();
      this.moduleMasterService.addModule(this.createReqVM).subscribe(response => {
        if (response != undefined) {
          this.addModuleResponseHolder = response;
          if (this.addModuleResponseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success("Module added successfully.", '', {
              timeOut: 3000,
            });
            let closePanel = true;
            this.closeSidePanel.emit(closePanel);
            this.createModuleform.reset();
            //this.router.navigate(['/moduleMaster/moduleList']);
          // location.reload();
           
          }
          else {
            this.loaderService.hide();
            this.toastr.error(this.addModuleResponseHolder.message, '', {
              timeOut: 3000,
            });
            let closePanel = false;
            this.closeSidePanel.emit(closePanel);
          }
        }
      });
    }
  }

}
